import { render, staticRenderFns } from "./GoogleApiUserDataPolicyLink.vue?vue&type=template&id=5a2b58be&"
import script from "./GoogleApiUserDataPolicyLink.vue?vue&type=script&lang=js&"
export * from "./GoogleApiUserDataPolicyLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports